<div
  [attr.id]="panelId() || null"
  role="dialog"
  aria-label="Select time"
  class="event-time-picker-dropdown-panel tw-box-border tw-flex tw-gap-4 tw-bg-white tw-p-3 tw-font-inter"
  (mousedown)="$event.stopPropagation()"
  (click)="$event.stopPropagation()"
>
  <div class="tw-flex tw-min-w-0 tw-flex-col">
    <span class="tw-mb-2 tw-px-1 tw-text-xs tw-font-medium tw-text-gray-500">Hours</span>
    <div
      class="tw-h-full time-list tw-overflow-y-auto tw-rounded-lg tw-border tw-border-gray-100 tw-bg-gray-50/80 tw-py-1"
      role="listbox"
      aria-label="Hours"
    >
      @for (hour of hourOptions(); track hour) {
        <button
          type="button"
          role="option"
          [attr.aria-selected]="hourIsSelected(hour)"
          class="tw-w-full tw-border-0 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-font-inter tw-transition-colors focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-inset"
          [ngClass]="{
            'tw-bg-blue-600 tw-font-semibold tw-text-white hover:tw-bg-blue-700 focus-visible:tw-ring-white': hourIsSelected(hour),
            'tw-bg-transparent tw-text-gray-900 hover:tw-bg-white focus-visible:tw-ring-blue-500': !hourIsSelected(hour)
          }"
          (click)="emitHour(hour)"
        >
          {{ hour }}
        </button>
      }
    </div>
  </div>
  <div class="tw-flex tw-min-w-0 tw-flex-col">
    <span class="tw-mb-2 tw-px-1 tw-text-xs tw-font-medium tw-text-gray-500">Minutes</span>
    <div
      class="tw-h-full time-list tw-overflow-y-auto tw-rounded-lg tw-border tw-border-gray-100 tw-bg-gray-50/80 tw-py-1"
      role="listbox"
      aria-label="Minutes"
    >
      @for (minute of minuteOptions(); track minute) {
        <button
          type="button"
          role="option"
          [attr.aria-selected]="minuteIsSelected(minute)"
          class="tw-w-full tw-border-0 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-font-inter tw-transition-colors focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-inset"
          [ngClass]="{
            'tw-bg-blue-600 tw-font-semibold tw-text-white hover:tw-bg-blue-700 focus-visible:tw-ring-white': minuteIsSelected(minute),
            'tw-bg-transparent tw-text-gray-900 hover:tw-bg-white focus-visible:tw-ring-blue-500': !minuteIsSelected(minute)
          }"
          (click)="emitMinute(minute)"
        >
          {{ minute }}
        </button>
      }
    </div>
  </div>
</div>
